import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent {
  @Input() headerClass: string;
  @Input() isDisabled: boolean = false;
  @Input() isCollapsed: boolean = false;
}
